import React from 'react';
 
import { CircularProgress } from '@material-ui/core';


const Loader = ({show}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', }}>
      
       <CircularProgress color="dark" />
    </div>
  );
};

export default Loader;
